import type { BingoChallenge } from '@my-roadtrip/types';

const BINGO_CHALLENGES_POOL: Omit<BingoChallenge, 'id' | 'isCompleted' | 'completedAt'>[] = [
  {
    title: 'Roadside Diner',
    description: 'Eat a meal at a classic roadside diner.',
    points: 50,
  },
  {
    title: 'Vintage Car',
    description: 'Spot a car manufactured before 1980.',
    points: 25,
  },
  {
    title: 'National Monument',
    description: 'Visit any national monument or park.',
    points: 100,
  },
  {
    title: 'Local Souvenir',
    description: 'Buy a souvenir from a small, local shop.',
    points: 40,
  },
  {
    title: 'Sunrise/Sunset',
    description: 'Watch a full sunrise or sunset.',
    points: 60,
  },
  {
    title: 'State Line Crossing',
    description: 'Take a photo at a "Welcome to..." state sign.',
    points: 30,
  },
  {
    title: 'Unusual Roadside Attraction',
    description: 'Visit a quirky or unusual roadside attraction.',
    points: 75,
  },
  {
    title: 'Talk to a Local',
    description: 'Have a conversation with a local for more than 5 minutes.',
    points: 45,
  },
  {
    title: 'Gas Station Snack',
    description: 'Try a unique snack you can only find at a gas station.',
    points: 20,
  },
  {
    title: 'Scenic Overlook',
    description: 'Stop at a designated scenic overlook and take a picture.',
    points: 35,
  },
  {
    title: 'Hike a Trail',
    description: 'Complete a short hike on a local trail.',
    points: 80,
  },
  {
    title: 'Local Brew',
    description: 'Try a coffee or beer from a local roaster or brewery.',
    points: 40,
  },
];

/**
 * Generates a random list of bingo challenges.
 * @param count - The number of challenges to generate.
 * @returns An array of BingoChallenge objects.
 */
export function generateBingoChallenges(count = 9): BingoChallenge[] {
  const shuffled = [...BINGO_CHALLENGES_POOL].sort(() => 0.5 - Math.random());
  const selected = shuffled.slice(0, count);

  return selected.map((challenge, index) => ({
    ...challenge,
    id: `bingo_${Date.now()}_${index}`,
    isCompleted: false,
  }));
}
